"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionStore = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var services_1 = require("../services");
var CollectionStore = /** @class */ (function () {
    function CollectionStore() {
    }
    CollectionStore.prototype.has = function (revision) {
        var rest = services_1.Services.Department.rest;
        var ikeCollection = rest.Collection.getModel(revision);
        if (!ikeCollection.hasFetched) {
            return false;
        }
        return ikeCollection.hasFetched;
    };
    CollectionStore.prototype.get = function (revision) {
        var _a;
        if (!revision) {
            return null;
        }
        var rest = services_1.Services.Department.rest;
        var collection = (_a = rest.Collection.getModel(revision)) === null || _a === void 0 ? void 0 : _a.value;
        if (collection == null) {
            return null;
        }
        return collection;
    };
    CollectionStore.prototype.getHistory = function (collectionUuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = services_1.Services.Department.rest.query(core_shared_1.IkeRestObjects.CollectionHistory);
                query.where.uuid = collectionUuid;
                return [2 /*return*/, query.findAll()];
            });
        });
    };
    CollectionStore.prototype.fetch = function (revision) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = services_1.Services.Department.rest;
                        return [4 /*yield*/, rest.Collection.getModel(revision).fetch()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectionStore.prototype.search = function (text) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentDepartment, data, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentDepartment = services_1.Services.Department.current;
                        if (currentDepartment == null) {
                            return [2 /*return*/, Promise.resolve([])];
                        }
                        data = {
                            type: 'collection',
                            text: text
                        };
                        return [4 /*yield*/, services_1.Services.Department.rest.Collection.search(data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.results];
                }
            });
        });
    };
    return CollectionStore;
}());
exports.CollectionStore = CollectionStore;
//# sourceMappingURL=collection.store.js.map